import axios from 'axios'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004'),
    service: '/fdc/analysis'
  }
}

export default {
  /**
   * Parameter Analysis
   */
  getTraceDatas: async (params) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/trace-datas', params)
      return response.data === null ? [] : response.data
    } catch (error) {
      console.error(error)
    }
  },

  /**
   * Summary Analysis
   */
  getSummaryDatas: async (params) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/summary-datas', params)
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * SPC Analysis
   */
  getSpcSummaryDatas: async (params) => {
    try {
      let response = await axios.post(config().url + config().port + config().service + '/spc/summary-datas', params)
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getSpcDatas: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/spc-datas', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  getFaultAlarmDatas: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/fault-alarm-datas', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Multivariate Analysis
   */
  /**
   * @summary MVA SummayData 조회
   */
  runFeatureSelection: async (payload, callback) => {
    // console.log('getFeatureImportance')
    const url = config().url.concat(config().port, config().service, '/mva/feature-selection') // 원래 /analysis/summary-list
    await axios
      .post(url, payload.paramData, { maxContentLength: 200000000000000 })
      .then(response => {
        callback(response.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  /**
   * @summary MVA SummayData 조회
   */
  runFeatureSelection2: async (payload, callback) => {
    // console.log('fdcdetection.getFeatureImportance 2')
    const url = config().url.concat(config().port, config().service, '/mva/feature-selection2')
    await axios
      .post(url, payload.paramData, { maxContentLength: 200000000000000 })
      .then(response => {
        callback(response.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  /**
   * @summary pcaTrainingModel 조회
   */
  runPcaTrain: async (payload, callback) => {
    const url = config().url.concat(config().port, config().service, '/mva/pca-train')
    await axios
      .post(url, payload.dataList, { maxContentLength: 200000000000000 })
      .then(response => {
        callback(response.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  /**
   * @summary pcaTrainingModel 조회
   */
  runHotelingT2: async (payload, callback) => {
    const url = config().url.concat(config().port, config().service, '/mva/hoteling-t2')
    await axios
      .post(url, payload.dataList, { maxContentLength: 200000000000000 })
      .then(response => {
        callback(response.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },

  /**
   * EQP Comparison Analysis
   */
  /**
   * @summary Model List 조회
   * @description  PK중에 RECIPE_ID, STEP_ID는 Default 값 'ALL'로 설정
   * @param fab 장소
   * @param eqpId 장비 ID
   * @param moduleId 모듈 ID
   * @param modelType UVA, MVA 구분
   * @param uvaType UVA 타입(SETPOINT, FORMULA) UVA일때만
   */
  runEqpComparison: async (payload, callback) => {
    const url = config().url.concat(config().port, config().service, '/eqp-comparison')

    await axios
      .post(url, payload)
      .then(response => {
        callback(response)
      })
      .catch(err => {
        console.error(err)
      })
  },

  /**
   * Model
   */
  getSpcSummaryLots: async (params) => {
    try {
      let response = await axios.get(config().url + config().port + config().service + '/spc/summary-lots', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.error(error)
    }
  },
  runPcaBuild: async (payload, callback) => {
    console.log('saveBuildData')
    const url = config().url.concat(config().port, config().service, '/mva/pca-build')
    await axios
      .post(url, payload.dataList, { maxContentLength: 200000000000000 })
      .then(response => {
        callback(response)
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
